<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 4" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-2" v-if="!edicao">Cadastro de URA</div>
      <v-row>
        <v-col cols="3">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição da URA"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model.number="form.quantidadeDigitos"
            :error-messages="quantidadeDigitosErrors"
            label="Quantidade de Dígitos"
            type="number"
            outlined
            @input="$v.form.quantidadeDigitos.$touch()"
            @blur="$v.form.quantidadeDigitos.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model.number="form.quantidadeDeLoops"
            :error-messages="quantidadeDeLoopsErrors"
            label="Quantidade de Loops"
            type="number"
            outlined
            @input="$v.form.quantidadeDeLoops.$touch()"
            @blur="$v.form.quantidadeDeLoops.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model.number="form.timeout"
            :error-messages="timeoutErrors"
            label="Tempo de espera"
            type="number"
            outlined
            @input="$v.form.timeout.$touch()"
            @blur="$v.form.timeout.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.audioPrincipal"
            :error-messages="audioPrincipalErrors"
            :items="audioPrincipal"
            outlined
            label="Áudio Principal"
            @input="$v.form.audioPrincipal.$touch()"
            @blur="$v.form.audioPrincipal.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select dense v-model="form.audioAviso" :items="audioAviso" outlined label="Áudio de aviso" />
        </v-col>
        <v-col cols="4">
          <v-select dense v-model="form.audioErro" :items="audioErro" outlined label="Áudio de Erro" />
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Rotas"
        :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
        @dragUpdate="updateRotasGeral($event)"
        :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
      />

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import urasStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import DraggAndDrop from '../_components/DraggAndDrop'
import UrasHttpService from '../_services/UrasHttpService'

export default {
  name: 'CadastroUra',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      audioPrincipal: '',
      audioAviso: '',
      audioErro: '',
      quantidadeDigitos: 1,
      quantidadeDeLoops: 0,
      rotaEntrada: [],
      timeout: '',
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    audioPrincipal: [],
    audioAviso: [{ value: null, text: '' }],
    audioErro: [{ value: null, text: '' }],
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroURAModulePABXStore', ['getRotasDisponiveis', 'getUraSelecionada', 'getAudios']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroURAModulePABXStore', urasStore)

    await Promise.all([this.listarRotas(), this.listarAudios()])

    this.getAudios.forEach(audio => {
      this.audioPrincipal.push({ text: audio.description, value: audio._id })
      this.audioAviso.push({ text: audio.description, value: audio._id })
      this.audioErro.push({ text: audio.description, value: audio._id })
    })

    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    if (this.edicao === 'true') {
      this.form = this.getUraSelecionada

      const arrayrotasSelecionadas = Object.values(this.getUraSelecionada.rotaEntrada)

      arrayrotasSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(
          rotaGeral => rotaGeral._id === rotasSelecionadas
        )

        if (indexRotaGeral !== -1) {
          this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
        }
      })
    }

    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroURAModulePABXStore', ['listarAudios', 'listarRotas']),
    updateRotasGeral(event) {
      this.form.rotaEntrada = formatarRota(event)
    },

    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.rotaEntrada['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this._id) {
          delete this.form.numero
          await UrasHttpService.putUra(this.form)
        } else {
          await UrasHttpService.postUra(this.form)
        }
        this.$router.push({ name: 'Uras' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Uras' })
    },
  },
}
</script>
